import { walkCast } from './walkCast';
import type { CastNode } from '../types';

/**
 * Sets the `included` flag on every paragraph, table, row, and cell reachable
 * from `node` to `value`. Mutates the tree in place. CastRoot and CastText
 * are visited but have no `included` field, so they are left untouched.
 */
export function mutateAllIncluded(node: CastNode, value: boolean): void {
  walkCast(node, current => {
    switch (current.type) {
      case 'paragraph':
      case 'section':
      case 'table':
      case 'tableCell':
      case 'tableRow':
        current.included = value;
        break;
      case 'link':
      case 'root':
      case 'selectionEnd':
      case 'selectionStart':
      case 'text':
        break;
    }
  });
}
